export const FORM_DEFAULTS = Object.freeze({
  DEFAULT_APPOINTMENT_DURATION: 45,
  START_INCREMENT: 45,
  INCREMENT_INTERVAL: 'minutes',
  NEXT_START_INCREMENT: 1,
  NEXT_START_INTERVAL: 'hour'
})

export const RELATIONSHIP_TYPES = [
  { id: 14, name: 'clinical.people.anamnesis.family_relation_types.wife' },
  { id: 15, name: 'clinical.people.anamnesis.family_relation_types.husband' },
  { id: 9, name: 'clinical.people.anamnesis.family_relation_types.son' },
  { id: 10, name: 'clinical.people.anamnesis.family_relation_types.daughter' },
  { id: 16, name: 'clinical.people.anamnesis.family_relation_types.another_family_member' },
  { id: 17, name: 'clinical.people.anamnesis.family_relation_types.friend' },
]
